import PortalLayout from "./PortalLayout";
import { connect } from 'react-redux';

const FeesPortal = ({profile }) => {
    //console.log(profile)
    return ( 
        <PortalLayout>
            {
                profile && (
                    <div className="container row pt-5">
                    <div className="col s12 m4 l3">
                        <div className="card-panel grey lighten-5 z-depth-1 smooth-edge-2">
                            <h5 className="grey-text text-darken-2 center mt-1 mb-5 is-size-4">Term</h5>
                            <h5 className="grey-text has-text-weight-semibold center my-5 is-size-4">{profile.feesTerm}</h5>
                        </div>
                    </div>
                    <div className="col s12 m4 l3">
                        <div className="card-panel grey lighten-5 z-depth-1 smooth-edge-2">
                            <h5 className="grey-text text-darken-2 center mt-1 mb-5 is-size-4">Fees Paid</h5>
                            <h5 className="green-text text-darken-3 has-text-weight-semibold center my-5 is-size-4">${profile.feesPaid}</h5>
                        </div>s
                    </div>
                    <div className="col s12 m4 l3">
                        <div className="card-panel grey lighten-5 z-depth-1 smooth-edge-2">
                            <h5 className="grey-text text-darken-2 center mt-1 mb-5 is-size-4">Balance</h5>
                            <h5 className="red-text text-darken-3 has-text-weight-semibold center my-5 is-size-4">${profile.feesBalance}</h5>
                        </div>
                    </div>
                    <div className="col s12 m4 l3">
                        <div className="card-panel grey lighten-5 z-depth-1 smooth-edge-2">
                            <h5 className="grey-text text-darken-2 center mt-1 mb-5 is-size-4">Date:</h5>
                            <h5 className="grey-text has-text-weight-semibold center my-5 is-size-4">{profile.feesDate}</h5>
                        </div>
                    </div>
                </div>

                )
            }

        </PortalLayout>
     );
}
 
const mapStateToProps = (state) => {
    //console.log(state)
    return {
        profile: state.firebase.profile,
        id: state.firebase.auth.uid
    }   
    
}
 

export default connect(mapStateToProps)(FeesPortal);